/**
 * @generated SignedSource<<ca44a8016384c55b0a4e44503bcf1ffd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedContentModuleRegular_browseContentModule$data = {
  readonly description: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbMobileContentModuleRegular_browseContentModule" | "SbRespContentModuleRegular_browseContentModule">;
  readonly " $fragmentType": "BuySharedContentModuleRegular_browseContentModule";
};
export type BuySharedContentModuleRegular_browseContentModule$key = {
  readonly " $data"?: BuySharedContentModuleRegular_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedContentModuleRegular_browseContentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedContentModuleRegular_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileContentModuleRegular_browseContentModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleRegular_browseContentModule"
    }
  ],
  "type": "ContentModuleRegular",
  "abstractKey": null
};

(node as any).hash = "9436ea68954aec14a15233ce3475e8b5";

export default node;
